






















import Treecon from "@f/components/Treecons/Treecon.vue";
import useUserInfo from '@f/composables/useUserInfo';
import { getModalService } from "@f/services/Angular";
import { computed, defineComponent } from "@vue/composition-api";
import CommonCardGame from "../../Components/CommonCardGame.vue";
import CommonHeaderGame from "./../../Layout/CommonHeaderGame.vue";

export default defineComponent({
  name: "GameAuthentication",
  components: {
    CommonHeaderGame,
    Treecon,
    CommonCardGame,
  },
  setup() {
    const { userInfo } = useUserInfo()
    const authenticated = computed(() => !!userInfo.value)
    const openAuthenticationModal = () => {
      if (!authenticated.value) {
        getModalService()?.open({
          templateUrl: "login.html",
          easyClose: false,
          fitcontent: true,
        });
      }
    };
    return {
      openAuthenticationModal,
    };
  },
});
